module.exports = "/_next/static/images/customer-review-sarah1@2x-min-6be419cb23ad3db906b11ded59c9cccf.png.webp";